
export default
	inject: textColor: default: ''

	props:
		section: Object
		hasBgImage: Boolean

	computed:
		computedTextColor: -> @textColor || @section.textColor

	methods:
		wrapDecimalNumbers: (str) ->
			return str unless str
			str.replace /\d+\.\d+/g, '<span class="tight-tracking">$&</span>'


